import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title}封面 - 天天漫画网`}
          title={`${comic.title} ${comic.latestChapter}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-xs font-bold text-background-50 ${
            comic.status === "连载中" ? "bg-accent-500" : "bg-foreground-700"
          }`}
        >
          {comic.status}
        </span>
        {comic.hot && (
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-secondary-500 px-2 py-0.5 text-xs font-bold text-foreground-950">
            <i className="ri-fire-fill"></i>热
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-900 group-hover:text-primary-600">
          {comic.title}
        </h3>
        <div className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
          <i className="ri-star-fill text-secondary-500"></i>
          <span>{comic.rating.toFixed(1)}</span>
          <span className="mx-1">·</span>
          <span className="truncate">{comic.category}</span>
        </div>
        <p className="mt-1.5 truncate text-xs text-primary-600">{comic.latestChapter}</p>
      </div>
    </Link>
  );
}